import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

export const PrejoinSkeleton = () => {
  return (
    <F0Dialog isOpen onClose={() => {}}>
      <Box
        width="full"
        height="s400"
        position="relative"
        alignItems="center"
        justifyContent="center"
      >
        <Skeleton isLoading height="full" />

        <Box width="full" gap="s12" alignItems="center" paddingTop="s16">
          <Box style={{ width: '100px' }} flexDirection="row" gap="s12">
            <Skeleton isLoading height="s40" />
            <Skeleton isLoading height="s40" />
          </Box>
          <Box width="full" flexDirection="row" gap="s12">
            <Skeleton isLoading height="s32" />
            <Skeleton isLoading height="s32" />
            <Skeleton isLoading height="s32" />
            <Skeleton isLoading height="s32" />
          </Box>
        </Box>
      </Box>
    </F0Dialog>
  )
}
